"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M14.297 6.043a.5.5 0 0 1 .537.085l5 4.5a.5.5 0 0 1 0 .744l-5 4.5A.5.5 0 0 1 14 15.5v-1.967c-2.165.157-3.714.497-5.04 1.113-1.43.664-2.642 1.668-4.098 3.199a.5.5 0 0 1-.823-.538c1.144-2.734 2.303-4.819 3.916-6.278 1.54-1.395 3.452-2.181 6.045-2.48V6.5a.5.5 0 0 1 .297-.457M15 7.623V9a.5.5 0 0 1-.455.498c-2.673.243-4.492.98-5.92 2.272-.983.89-1.803 2.063-2.583 3.575.798-.662 1.603-1.192 2.497-1.607 1.593-.74 3.427-1.096 5.933-1.237A.5.5 0 0 1 15 13v1.377L18.753 11z"
}), 'Share');
//# sourceMappingURL=index.js.map